<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu các hoạt động thao tác dữ liệu trên hệ thống</strong>
                    </div>
                    <b-form @submit.prevent="search" id="form-log">
                        <b-row>
                            <b-col sm="6">
                                <!--<b-form-group label="Đơn vị quản lý:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" ref="unitTree" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption"></unit-tree>
                                </b-form-group>-->
                                <b-form-group label="Loại thao tác:"
                                              label-for="input-action"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 class="form-control no-padding"
                                             v-model="searchForm.action" :options="listActions"
                                             allowClear="true"
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                               
                                <b-form-group label="Loại bản ghi:"
                                              label-for="input-action"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 class="form-control"
                                             v-model="searchForm.logLevel" :options="listLogLevels"
                                             allowClear="true"
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <!--<b-row>
                            <b-col sm="6">
                                <b-form-group label="Tài khoản thực hiện:"
                                              label-for="input-actor"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input id="input-actor" v-model="searchForm.actor"></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Từ khóa tìm kiếm:"
                                              label-for="input-keyword"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input id="input-keyword" v-model="searchForm.keyword"></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>-->
                        <b-row>

                            <b-col sm="6">
                                <b-form-group label="Tên tài khoản:"
                                              label-for="input-actor"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input id="input-actor" v-model="searchForm.actor"></b-form-input>
                                </b-form-group>

                                <b-form-group label="Từ ngày:"
                                              label-for="input-startdate"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker id="input-startdate" v-model="searchForm.startDate" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Từ khóa tìm kiếm:"
                                              label-for="input-keyword"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input id="input-keyword" v-model="searchForm.keyword"></b-form-input>
                                </b-form-group>
                                <b-form-group label="Đến ngày:"
                                              label-for="input-enddate"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker id="input-enddate" v-model="searchForm.endDate" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="text-center">
                            <b-col sm="12">
                                <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="logging/system-logs"
                            gridName="Danh sách các hoạt động thao tác dữ liệu trên hệ thống"
                            ref="actionLogTable">
                        <template v-slot:cell(_actions)="row">
                            <b-button size="sm" @click="row.toggleDetails" class="mr-2" variant="info">
                                <span v-if="!row.detailsShowing" title="Xem chi tiết">Xem</span>
                                <span v-else title="Ẩn chi tiết">Ẩn</span>
                            </b-button>
                        </template>
                        <template v-slot:cell(logLevel)="row">
                            <span :class="row.item.logLevel == 'Info' ? 'text-success' : 'text-danger'">{{ row.item.logLevel == 'Info' ? 'Thông tin' : 'Lỗi' }}</span>
                        </template>
                        <template v-slot:cell(action)="row">
                            {{ getActionName(row.item.action) }}
                        </template>
                        <template v-slot:cell(date)="row">
                            {{ row.item.date | formatTime }}
                        </template>
                        <template v-slot:row-details="row">
                            <b-card>
                                <ul style="max-width: 1200px">
                                    <li>
                                        Thông tin request:
                                        <ul>
                                            <li v-for="(value, key) in JSON.parse(row.item.origin)" :key="key">{{ key }}: {{ value }}</li>
                                        </ul>
                                    </li>
                                    <li>Thao tác: {{ row.item.date | formatTime }} - {{ row.item.message }}</li>
                                    <li v-if="row.item.exception">Thông tin lỗi: {{ row.item.exception }}</li>
                                    <li v-if="row.item.data">
                                        Dữ liệu cập nhật:
                                        <ul>
                                            <li v-for="(value, key) in JSON.parse(row.item.data)" :key="key"><span :title="key">{{key}}:</span> <strong>{{ value }}</strong></li>
                                        </ul>
                                    </li>
                                </ul>
                                <b-button size="sm" @click="row.toggleDetails">Ẩn chi tiết</b-button>
                            </b-card>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { authorizationMixin } from '@/shared/mixins'
    import { mapState } from 'vuex'

    export default {
        name: 'ListAssetSource',
        mixins: [authorizationMixin],
        data() {
            return {
                listLogLevels: [
                    //{ id: 'Trace', text: 'Trace' },
                    //{ id: 'Debug', text: 'Debug' },
                    { id: 'Info', text: 'Thông tin' },
                    //{ id: 'Warning', text: 'Cảnh báo' },
                    { id: 'Error', text: 'Lỗi' },
                    //{ id: 'Critical', text: 'Rất nghiêm trọng' }
                ],
                listActions: [
                    { id: 1, text: 'Thêm mới' },
                    { id: 2, text: 'Sửa' },
                    { id: 3, text: 'Xóa' },
                    { id: 4, text: 'Đăng nhập' },
                    { id: 5, text: 'Đăng xuất' }
                ],
                unitId: null,
                searchForm: {
                    actor: null,
                    action: null,
                    startDate: null, //new Date().firstDayOfMonth().formatDate(),
                    endDate: null,
                },
                gridOptions: {
                    fields: [
                        { key: 'actor', label: 'Tên tài khoản', sortable: true },
                        { key: 'date', label: 'Thời gian', sortable: true },
                        { key: 'message', label: 'Thao tác người dùng', sortable: true },
                        { key: 'action', label: 'Loại thao tác', sortable: true },
                        { key: 'logLevel', label: 'Loại bản ghi', sortable: true }
                    ],
                    sortBy: 'date',
                    sortDesc: true
                },
                statuses: [
                    { id: 1, text: 'active' },
                    { id: 0, text: 'inactive' }
                ],
            }
        },
        computed: {
            ...mapState({
                tableComments: (state) => state.common.tableComments
            })
        },
        created() {
        },
        mounted(){
            
            const element = document.getElementById("form-log");
            element.querySelector(".bv-no-focus-ring").classList.add("col-md-6");
        },
        methods: {
            search() {
                this.$refs.actionLogTable.refresh();
            },
            getActionName(action) {
                switch (action) {
                    case 'Add': return 'Thêm mới';
                    case 'Update': return 'Sửa';
                    case 'Delete': return 'Xóa';
                    case 'Login': return 'Đăng nhập';
                    case 'Logout': return 'Đăng xuất';
                }
            },
            getColumnName(columnName, tableName) {
                if (tableName) {
                    var col = this.tableComments.find(x => x.columnName == columnName && x.tableName == tableName);

                    if (col) {
                        if (!col.comments) return columnName;

                        var index = col.comments.indexOf('.');
                        return index == - 1 ? col.comments : col.comments.substr(0, index);
                    } else {
                        return columnName;
                    }
                } else {
                    return columnName;
                }
            }
        }
    }
</script>
<style>
.form-row .bv-no-focus-ring{
    padding: 0 !important;
}
</style>
